import type { AdminLoginResponse } from '../types/auth.type';
import type { AuthenticatedUser } from '../types/authenticated-user.type';
import { getTokenPayload } from '@/core/utils/jwt.utils';

/**
 * Maps the backend admin login response to the frontend AuthenticatedUser format
 * @param response - Raw backend response
 * @returns AuthenticatedUser object for frontend use
 */
export function mapAdminLoginResponse(response: AdminLoginResponse): AuthenticatedUser {
  // Extract email and other metadata from JWT token
  const tokenPayload = getTokenPayload({ value: response.accessToken });
  const email = tokenPayload.email || '';
  const emailVerified = tokenPayload.user_metadata?.email_verified ?? false;

  // Extract display name from email (fallback)
  const displayName = email.split('@')[0];

  console.log('🔄 [MAPPER] Mapping admin login response', {
    adminUserId: response.adminUserId,
    email,
    emailVerified,
    displayName,
  });

  return {
    userId: String(response.adminUserId),
    displayName,
    email,
    accessToken: response.accessToken,
    refreshToken: response.refreshToken,
    emailVerified,
    avatarUrl: undefined,
    permissions: [],
    role: null,
  };
}
